(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2255],{

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20});

/***/ }),

/***/ 832:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/error-qty.06cab676.svg","height":20,"width":16});

/***/ }),

/***/ 70561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57333);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75653);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36513);
/* harmony import */ var _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10502);
/* harmony import */ var _public_images_error_qty_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(832);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11859);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19514);
/* harmony import */ var _components_PreviewCart_v1_analytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8181);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93284);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46201);















const PreviewCartTile = (props)=>{
    var ref, ref1;
    const { i18n ={} , data , checkoutMode , productEventInfo , presetConfigs =""  } = props || {};
    const { sku ="" , isComboSku =false , isBundleParent =false , backOrder =false , category ="" , id ="" , bundleItemsCount =0 , availableQty ="" , zipCode =""  } = data || {};
    const { outOfStock ="" , availableToShipMsg =()=>{}  } = i18n;
    const { qtyLoading =false  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectCartState */ .xw);
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    const [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.quantity);
    const [previewCartAlert, setPreviewCartAlert] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        show: false,
        mssg: ""
    });
    const [pdpUrl, setpdpUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [scene7AccountName, setScene7AccountName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [swatchUrl, setSwatchUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    let totalArea = "";
    let productType = "";
    let totalLabel = "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setQuantity(data.quantity);
        if (data === null || data === void 0 ? void 0 : data.additionalData) setLabel();
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_10__/* .getConfig */ .i)().then((config)=>{
            constructPdpUrl();
            const { general: { scene7AccountName ="" , swatchUrl ="" , siteName =""  }  } = config;
            setScene7AccountName(scene7AccountName);
            setSwatchUrl(swatchUrl);
            setSiteName(siteName);
        });
    }, []);
    const handleCallBack = (stock)=>{
        if (stock) {
            const mssg = availableToShipMsg(stock);
            setPreviewCartAlert({
                show: true,
                mssg: "".concat(mssg)
            });
        } else {
            setPreviewCartAlert({
                show: true,
                mssg: outOfStock
            });
        }
    };
    const handleChange = (qty)=>{
        setQuantity(qty);
        setPreviewCartAlert({
            show: false,
            mssg: ""
        });
        const payload = {
            id,
            sku,
            quantity: qty,
            isComboSku,
            isBundleParent,
            stockCheck: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .checkStock */ .yyd)(backOrder, category),
            cb: handleCallBack,
            zipCode
        };
        (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__/* .handleQuantityChange */ .bQ)(payload);
    };
    const constructPdpUrl = async ()=>{
        let pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getPDPUrl */ .ir5)(data.category, data.slug);
        if (data.category !== "Install Services" && data.category !== "Design Services") {
            pdpUrl = "".concat(pdpUrl).concat((pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.includes("?type=part")) ? "&" : "?", "skuId=").concat(data.sku);
        }
        setpdpUrl(pdpUrl);
    };
    const handleRemoveFromCart = ()=>{
        (0,_components_PreviewCart_v1_analytics__WEBPACK_IMPORTED_MODULE_11__/* .previewCartUpdateAnalytics */ .uK)(data);
        const payloadData = {
            id,
            quantity: quantity,
            isBundle: isComboSku,
            sku,
            isBundleParent,
            isComboSku
        };
        (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__/* .removeCartItem */ .B8)(payloadData);
    };
    const handleProductClick = ()=>{
        const productInfo = (0,_components_PreviewCart_v1_analytics__WEBPACK_IMPORTED_MODULE_11__/* .getProductInfoAnalytics */ .Pt)(data);
        (0,_components_PreviewCart_v1_analytics__WEBPACK_IMPORTED_MODULE_11__/* .callOverlayEventInfoAnalytics */ .rD)(pdpUrl, productEventInfo, productInfo, data);
    };
    const setLabel = ()=>{
        if (data.additionalData.roomInfo && data.additionalData.roomInfo.length > 0) {
            const roomInfoDetails = JSON.parse(data.additionalData.roomInfo[0]);
            totalArea = roomInfoDetails.totalArea ? roomInfoDetails.totalArea : "";
            productType = roomInfoDetails.productType ? roomInfoDetails.productType : "";
            totalLabel = productType === "tile" ? i18n.squreFt : i18n.linearFt;
        }
    };
    const presetConfigsData = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imageUrl = data === null || data === void 0 ? void 0 : data.image;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(presetConfigsData) && (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) === (data === null || data === void 0 ? void 0 : (ref = data.brand) === null || ref === void 0 ? void 0 : ref.toLowerCase())) {
        const presetImageUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$f)(width, swatchUrl, data === null || data === void 0 ? void 0 : data.image, presetConfigsData, scene7AccountName);
        imageUrl = presetImageUrl;
    }
    const discountVal = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .isPriceZero */ .YN4)(data.discountedPricePerQuantity) ? data.discountedPriceProductLevel : data.discountedPricePerQuantity;
    var _quantity;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.comboChild && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "preview-cart-item__item-of",
                children: i18n.itemOf(props.comboChild.index, props.comboChild.count)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "preview-cart-item",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: pdpUrl,
                        onClick: handleProductClick,
                        "data-testid": "pdpClick",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            onError: (e)=>{
                                return e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src;
                            },
                            src: imageUrl || data.image,
                            alt: "",
                            className: "preview-cart-item__image"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "preview-cart-item__details",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "preview-cart-item__header",
                                children: data.brand && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "preview-cart-item__brand",
                                    children: data.brand
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: pdpUrl,
                                onClick: handleProductClick,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "preview-cart-item__name",
                                    "data-testid": "prodName",
                                    children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getProductDisplayName */ .Lkg)(data)
                                })
                            }),
                            data.category !== "Install Services" && data.category !== "Design Services" && data.color !== "Not Applicable" && !isBundleParent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "preview-cart-item__finish",
                                "data-testid": "prodColor",
                                children: [
                                    i18n.colorFinish,
                                    ": ",
                                    data.color
                                ]
                            }) : null,
                            checkoutMode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__skuId",
                                children: [
                                    i18n.sku,
                                    ":",
                                    data.customerFacingSKU ? data.customerFacingSKU : data.sku
                                ]
                            }) : null,
                            previewCartAlert.show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                                        alt: previewCartAlert.mssg
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: previewCartAlert.mssg
                                    })
                                ]
                            }),
                            !previewCartAlert.show && data.outOfStock && availableQty < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                                        alt: i18n.outOfStock
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: i18n.outOfStock
                                    })
                                ]
                            }) : null,
                            !previewCartAlert.show && data.outOfStock && availableQty > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _public_images_error_qty_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === null || _public_images_error_qty_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_error_qty_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src,
                                        alt: availableToShipMsg(availableQty)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: availableToShipMsg(availableQty)
                                    })
                                ]
                            }) : null,
                            (productType === "tile" || productType === "trim") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__additional-Info",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "preview-cart-item__additional-Info-label",
                                        children: [
                                            i18n === null || i18n === void 0 ? void 0 : (ref1 = i18n.total) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase(),
                                            " ",
                                            totalLabel === null || totalLabel === void 0 ? void 0 : totalLabel.toUpperCase()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "preview-cart-item__additional-Info-detail",
                                        children: [
                                            ": ",
                                            totalArea
                                        ]
                                    })
                                ]
                            }),
                            isBundleParent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "bundles-checkout-message",
                                children: i18n.includedItemsQty(bundleItemsCount)
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "preview-cart-item__footer",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "preview-cart-item__qty",
                                        children: !checkoutMode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            source: "cart-preview",
                                            cartData: props.cartData,
                                            productData: data,
                                            size: "small",
                                            value: quantity,
                                            onChange: (qty)=>handleChange(qty),
                                            loading: qtyLoading || props.loading,
                                            isBundleParent: isBundleParent
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "preview-cart-item__qty-label",
                                            "data-testid": "prodQuantity",
                                            children: "".concat(i18n.qtyLabel, ": ").concat(data.quantity)
                                        })
                                    }),
                                    !props.comboChild && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "preview-cart-item__price-details",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "preview-cart-item__price",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_14__/* .NumericFormat */ .h3, {
                                                    value: data.discountPrice > 0 ? data.discountPrice * Number((_quantity = data.quantity) !== null && _quantity !== void 0 ? _quantity : 1) : data.totalPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    "aria-description": i18n.unitPrice,
                                                    prefix: props.currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            data.discountPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "preview-cart-item__discount-container",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "preview-cart-item__offPercent",
                                                        children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : "".concat(props.currencySign).concat(discountVal, " ").concat(i18n.off)
                                                    }),
                                                    data.discountPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "preview-cart-item__discount",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_14__/* .NumericFormat */ .h3, {
                                                            value: data.unitPrice * data.quantity,
                                                            displayType: "text",
                                                            "aria-description": i18n.strikedPrice,
                                                            thousandSeparator: true,
                                                            prefix: props.currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !checkoutMode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "preview-cart-item__remove ".concat(props.loading ? "--loading" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                                    onClick: handleRemoveFromCart,
                                    "data-testid": "removeFromCart",
                                    children: i18n.remove
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewCartTile);


/***/ }),

/***/ 56243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3372);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24071);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _components_checkout_localization__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(95005);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55760);
/* harmony import */ var _components_checkout_OrderReview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73272);
/* harmony import */ var _components_Shared_ExpressCheckout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66553);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46201);
/* harmony import */ var _components_core_Collapsible__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78803);
/* harmony import */ var _components_cart_analytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50209);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(60475);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78145);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25935);
/* harmony import */ var _components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27173);
/* harmony import */ var _public_icons_small_tooltip_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36023);






















const OrderSummary = (props)=>{
    const { subtotal , totalPromotions , estimatedTax , estimatedTotal , promoCodes =[] , i18n ={} , checkoutMode ="" , shippingDone ="" , status , toastError , dispatchCallback , cartItems =[] , disableCheckout , checkoutUrl , currencySign , oldPromoCodes , oldDiscountCodes , shippingAllTotal =[] , legalLinks ={} , technicalErrorMessage ={} , placeOrderTechnicalErrorMsg ="" , placeOrderBtnDisableMsg =""  } = props || {};
    const { cart: activeCart = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectCartState */ .xw);
    const { placeOrderErrorTitleMsg ="" , placeOrderErrorMsg ="" , placeOrderErrorContactMsg ="" , placeOrderErrorHelpMsg =""  } = technicalErrorMessage;
    const { isPaymentTechnicalErrorFailed =false , isPaymentDisableAction =false  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_16__/* .checkoutState */ .TG);
    const { key: cartKey = ""  } = activeCart;
    const isLoading = status === "loading";
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [technicalErrorModal, setTechnicalErrorModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [disablePaymentBtn, setDisablePaymentBtn] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common");
    const staticText = (0,_components_checkout_localization__WEBPACK_IMPORTED_MODULE_21__/* .getTranslations */ .F)(t);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    const { genericError =""  } = staticText;
    const paymentButtonDisable = ()=>{
        (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__/* .addAnalyticsForErrorMessages */ .fd)(placeOrderBtnDisableMsg ? placeOrderBtnDisableMsg.replace(/<[^>]+>|&nbsp;/g, " ").trim() : genericError, "n/a", true, "close", ":let us help you");
        dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_16__/* .setPlaceOrderCountsAction */ .jJ)(0));
        dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_16__/* .setPaymentTechnicalFailedAction */ .t5)(false));
        dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_16__/* .setPaymentDisableBtnAction */ .Pk)(false));
        setDisablePaymentBtn(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isPaymentTechnicalErrorFailed && placeOrderTechnicalErrorMsg) {
            setIsModalOpen(true);
            (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__/* .addAnalyticsForErrorMessages */ .fd)(placeOrderTechnicalErrorMsg, "failure", isModalOpen);
        }
    }, [
        isPaymentTechnicalErrorFailed,
        placeOrderTechnicalErrorMsg
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isPaymentDisableAction) {
            setTechnicalErrorModal(true);
        }
    }, [
        isPaymentDisableAction
    ]);
    const handleModalClose = ()=>{
        (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__/* .addAnalyticsForErrorMessages */ .fd)(placeOrderTechnicalErrorMsg || genericError, "n/a", true, "close", ":let us help you");
        setIsModalOpen(false);
    };
    const handletechnicalErrorPopupClose = ()=>{
        setIsModalOpen(true);
    };
    const { shippingAddress: { streetName =""  } = {}  } = activeCart;
    const { freeShipping =""  } = staticText;
    const [promoCode, setPromoCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [promoError, setPromoError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [oldPromoCode, setOldPromoCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [oldDiscountCode, setOldDiscountCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handalScroll = ()=>{
        document.querySelector(".order-summary-mobile-sticky").classList.remove("is-sticky-load");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!checkoutMode) {
            const browserWidth = document.body.clientWidth;
            if (browserWidth <= 1023) {
                window.addEventListener("scroll", handalScroll);
                const observer = new IntersectionObserver(function(entries) {
                    const mobileSticky = document.querySelector(".order-summary-mobile-sticky");
                    if (mobileSticky) {
                        if (entries[0].intersectionRatio === 0) {
                            var ref;
                            (ref = mobileSticky.classList) === null || ref === void 0 ? void 0 : ref.add("isSticky");
                        } else if (entries[0].intersectionRatio === 1) {
                            var ref1;
                            (ref1 = mobileSticky.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("isSticky");
                        }
                    }
                }, {
                    threshold: [
                        0,
                        1
                    ]
                });
                observer.observe(document.querySelector(".order-summary"));
                return ()=>window.removeEventListener("scroll", handalScroll);
            }
        }
    }, [
        estimatedTotal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (promoError) (ref = document.getElementById("kf-cart-promo-error")) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        promoError
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setOldPromoCode(oldPromoCodes);
    }, [
        oldPromoCodes
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setOldDiscountCode(oldDiscountCodes);
    }, [
        oldDiscountCodes
    ]);
    const handleAddDiscount = function() {
        let promo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        promo.stopPropagation();
        const code = promo.target.value || promoCode.trim();
        const isAlreadyApplied = promoCodesData.some((item)=>item.code.toLowerCase() === code.toLowerCase());
        if (isAlreadyApplied) {
            var ref;
            setPromoError((ref = i18n === null || i18n === void 0 ? void 0 : i18n.alreadyAppliedErr) !== null && ref !== void 0 ? ref : "");
            setPromoCode("");
            return;
        }
        const payload = {
            actions: [
                {
                    code: code,
                    action: "addDiscountCode"
                }
            ]
        };
        var ref1;
        code ? dispatchCallback("discount", payload).unwrap().then(function(rsp) {
            handleDiscountResponse(rsp, oldPromoCode, oldDiscountCode, _constants_index__WEBPACK_IMPORTED_MODULE_6__.API_SUCCESS_STATUS);
            setPromoCode("");
        }).catch((er)=>{
            var ref;
            updatePromoAnalytics((ref = i18n === null || i18n === void 0 ? void 0 : i18n.invalidPromoErr) !== null && ref !== void 0 ? ref : "", undefined, "", "apply");
            var ref1;
            setPromoError((ref1 = i18n === null || i18n === void 0 ? void 0 : i18n.invalidPromoErr) !== null && ref1 !== void 0 ? ref1 : "");
        }) : setPromoError((ref1 = i18n === null || i18n === void 0 ? void 0 : i18n.noPromoErr) !== null && ref1 !== void 0 ? ref1 : "");
        var ref2;
        !code && updatePromoAnalytics((ref2 = i18n === null || i18n === void 0 ? void 0 : i18n.noPromoErr) !== null && ref2 !== void 0 ? ref2 : "", undefined, "", "apply");
    };
    const handleRemoveDiscount = (Id, code)=>{
        const payload = {
            actions: [
                {
                    action: "removeDiscountCode",
                    discountCode: {
                        typeId: "discount-code",
                        id: Id
                    }
                }
            ]
        };
        if (Id) {
            dispatchCallback("discount", payload).unwrap().then(async (resp)=>{
                await updatePromoAnalytics("success", resp, code, "remove");
                dispatchCallback("taxCalculation");
            }).catch(async ()=>{
                await updatePromoAnalytics("failed to remove discount code", undefined, code, "remove");
                toastError(i18n.removeDiscountErrorMsg);
            });
        }
    };
    const handleDiscountResponse = (payload, oldPromoCodePassed, oldDiscountCodePassed, status)=>{
        const appliedPromoCode = promoCode === null || promoCode === void 0 ? void 0 : promoCode.trim().toLowerCase();
        if (status === "succeeded" && payload) {
            // Check if previous discounts are removed by current discount
            let previousDiscountError = true;
            oldDiscountCodePassed.forEach((oldCode)=>{
                var ref;
                const newCode = (ref = payload.discountCodes) === null || ref === void 0 ? void 0 : ref.find((code)=>{
                    var ref, ref1, ref2, ref3;
                    return ((ref = code.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) === ((ref2 = oldCode.discountCode) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.code);
                });
                if (previousDiscountError && oldCode.state === "MatchesCart" && (oldPromoCodePassed === null || oldPromoCodePassed === void 0 ? void 0 : oldPromoCodePassed.find((promo)=>{
                    var ref, ref1;
                    return promo.code === ((ref = oldCode.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code);
                })) && (newCode === null || newCode === void 0 ? void 0 : newCode.state) === "ApplicationStoppedByPreviousDiscount") {
                    previousDiscountError = false;
                }
            });
            if (!previousDiscountError) {
                var ref;
                setPromoError((ref = i18n === null || i18n === void 0 ? void 0 : i18n.previousDiscountErr) !== null && ref !== void 0 ? ref : "");
                var ref1;
                updatePromoAnalytics((ref1 = i18n === null || i18n === void 0 ? void 0 : i18n.previousDiscountErr) !== null && ref1 !== void 0 ? ref1 : "", payload, appliedPromoCode, "apply");
                var ref2;
                toastError((ref2 = i18n === null || i18n === void 0 ? void 0 : i18n.previousDiscountErr) !== null && ref2 !== void 0 ? ref2 : "");
            } else {
                var ref3;
                var ref4;
                const resCode = (ref4 = (ref3 = payload.discountCodes) === null || ref3 === void 0 ? void 0 : ref3.find((code)=>{
                    var ref, ref1, ref2;
                    return ((ref = code.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.code) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === appliedPromoCode;
                })) !== null && ref4 !== void 0 ? ref4 : {};
                // Check if applied code can be combined with existing discounts
                if (resCode.state === _constants_index__WEBPACK_IMPORTED_MODULE_6__.stopedByPreviousDiscount) {
                    var ref5;
                    setPromoError((ref5 = i18n === null || i18n === void 0 ? void 0 : i18n.combinePromoErr) !== null && ref5 !== void 0 ? ref5 : "");
                    var ref6;
                    updatePromoAnalytics((ref6 = i18n === null || i18n === void 0 ? void 0 : i18n.combinePromoErr) !== null && ref6 !== void 0 ? ref6 : "", payload, appliedPromoCode, "apply");
                } else if (resCode.state === _constants_index__WEBPACK_IMPORTED_MODULE_6__.maxAppReached) {
                    var ref7;
                    setPromoError((ref7 = i18n === null || i18n === void 0 ? void 0 : i18n.maxAppReachedErr) !== null && ref7 !== void 0 ? ref7 : "");
                    var ref8;
                    updatePromoAnalytics((ref8 = i18n === null || i18n === void 0 ? void 0 : i18n.maxAppReachedErr) !== null && ref8 !== void 0 ? ref8 : "", payload, appliedPromoCode, "apply");
                } else if (resCode.state === _constants_index__WEBPACK_IMPORTED_MODULE_6__.discountMatchesCart) {
                    updatePromoAnalytics("success", payload, appliedPromoCode, "apply");
                    setPromoCode("");
                    setPromoError("");
                } else {
                    var ref9;
                    const errorMessage = (ref9 = i18n === null || i18n === void 0 ? void 0 : i18n.promoNotApplicable) !== null && ref9 !== void 0 ? ref9 : "";
                    setPromoError(errorMessage);
                    updatePromoAnalytics(errorMessage, payload, appliedPromoCode, "apply");
                }
            }
        }
        dispatchCallback("taxCalculation");
    };
    const updatePromoAnalytics = async (status, cartObj, promo, action)=>{
        const page = window.pageObj || {};
        const eventInfo = {
            eventAction: "cart:landing page:".concat(action, " promo"),
            eventName: "cart:landing page:".concat(action, " promo"),
            eventType: "navigation",
            eventMsg: status === "success" ? action === "apply" ? "promocode applied successfully" : "promocode removed successfully" : status === null || status === void 0 ? void 0 : status.toLowerCase(),
            eventStatus: status === "success" ? "success" : "failure",
            internalLinkName: action,
            internalLinkPosition: "cart",
            internalLinkType: "cart:promo",
            internalLinkZoneName: "cart:landing page:order summary",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            promoCode: promo
        };
        if (cartObj) {
            const { cart  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .calculateCartData */ .DpP)({
                cart: cartObj,
                i18n: {
                    productDiscounts: i18n.productDiscounts || "Product Discounts"
                }
            }, true);
            page.cart = cart;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const handleMouseOverTooltip = (type)=>{
        var ref, ref1;
        const eventText = "cart:landing page:".concat(type === (i18n === null || i18n === void 0 ? void 0 : i18n.oversizedFragileDelivery) ? type.toLowerCase().replace("/", " ") : "estimated ".concat(type), " mouseover");
        const eventLinkName = type === (i18n === null || i18n === void 0 ? void 0 : i18n.oversizedFragileDelivery) ? (ref1 = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(i18n === null || i18n === void 0 ? void 0 : i18n.oversizedDelivery)) === null || ref === void 0 ? void 0 : ref.split("  ")) === null || ref1 === void 0 ? void 0 : ref1.join(" ") : i18n === null || i18n === void 0 ? void 0 : i18n.shippingTooltip.toLowerCase();
        const eventInfo = {
            eventAction: eventText,
            eventName: eventText,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type === "tax" ? i18n === null || i18n === void 0 ? void 0 : i18n.taxTooltip.toLowerCase() : eventLinkName,
            internalLinkPosition: "cart",
            internalLinkType: "cart:mouseover",
            internalLinkZoneName: "cart:landing page:order summary",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        page.cart = props === null || props === void 0 ? void 0 : props.cart;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const promoCodesData = promoCodes.filter((e)=>{
        if (e.type !== "product" && e.type !== "no-code" && e.id) return e;
    });
    const { shipping ="" , shippingTooltip ="" , oversizedFragileDelivery ="" , oversizedDelivery ="" , freightShipping ="" , freightLabel ="" , editCart =""  } = i18n;
    if (shippingAllTotal.length) {
        const fromIndex = shippingAllTotal.findIndex((el)=>{
            return (el === null || el === void 0 ? void 0 : el.name) === freightShipping || (el === null || el === void 0 ? void 0 : el.name) === freightLabel;
        });
        const toIndex = shippingAllTotal.length - 1;
        shippingAllTotal.splice(toIndex, 0, shippingAllTotal.splice(fromIndex, 1)[0]);
    }
    const isCartItems = cartItems.length;
    const promoCodeAccordian = ()=>{
        const promoCodeIsOpenTitle = !isOpen ? "expand" : "collapse";
        setIsOpen(!isOpen);
        (0,_components_cart_analytics__WEBPACK_IMPORTED_MODULE_15__/* .addAnalyticsAccordianClickPromocode */ .ll)(promoCodeIsOpenTitle, activeCart);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "row no-gutters order-summary-wrapper sticky-order",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "order-summary ",
                    "aria-live": "polite",
                    "aria-busy": isLoading,
                    "aria-relevant": "text additions",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-summary__title",
                            role: "heading",
                            "aria-level": "2",
                            children: [
                                i18n.orderSummary,
                                " ",
                                checkoutMode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    href: _constants_index__WEBPACK_IMPORTED_MODULE_6__.cartPage,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        tabIndex: "0",
                                        role: "link",
                                        "aria-label": staticText.backToCart,
                                        className: "edit-cart-btn",
                                        onClick: ()=>(0,_components_cart_analytics__WEBPACK_IMPORTED_MODULE_15__/* .addAnalyticsEditCart */ .Qz)(window.location.origin.toLowerCase() + _constants_index__WEBPACK_IMPORTED_MODULE_6__.cartPage, activeCart),
                                        children: editCart
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                            value: isCartItems ? subtotal : "-",
                            label: i18n.subTotal,
                            prefix: currencySign
                        }),
                        Number(totalPromotions) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                            label: i18n.itemDiscount,
                            customCls: "order-font-medium",
                            value: totalPromotions > 0 ? totalPromotions * -1 : "",
                            prefix: currencySign
                        }) : null,
                        isCartItems ? shippingAllTotal.map(function() {
                            let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
                            const { name ="" , total =0  } = item;
                            const isFreightShipping = name === freightShipping || name === freightLabel;
                            const shippingName = !isFreightShipping ? "".concat(name, " ").concat(shipping) : oversizedFragileDelivery;
                            const totalAmount = Number(total) ? total : freeShipping;
                            const tooltip = !isFreightShipping ? shippingTooltip : oversizedDelivery;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                                    value: totalAmount,
                                    label: shippingName,
                                    icon: !checkoutMode ? _public_icons_small_tooltip_svg__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z === null || _public_icons_small_tooltip_svg__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_small_tooltip_svg__WEBPACK_IMPORTED_MODULE_20__/* ["default"].src */ .Z.src : null,
                                    alt: "".concat(i18n.shippingInfoAria, " ").concat(tooltip),
                                    tooltip: tooltip,
                                    onMouseOver: handleMouseOverTooltip,
                                    type: shippingName === oversizedFragileDelivery ? oversizedFragileDelivery : "shipping",
                                    prefix: currencySign
                                })
                            }, i);
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                            value: parseFloat(estimatedTax) || streetName ? estimatedTax : checkoutMode ? i18n.taxCalculatedInNextStep : i18n.calculatedInCheckout,
                            label: streetName ? i18n.tax : i18n.estimatedTax,
                            prefix: currencySign
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            role: "presentation",
                            "aria-hidden": "true",
                            className: "order-summary__separator cart_custom_margin_hr"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-summary-mobile-sticky   ".concat(!checkoutMode ? "is-sticky-load" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                                    label: shippingDone ? i18n.total : i18n.estimatedTotal,
                                    value: isCartItems ? estimatedTotal : "-",
                                    lineBreak: false,
                                    prefix: currencySign,
                                    valueSize: "large",
                                    customCls: "estimated-total"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "checkout-button-group",
                                    children: [
                                        !checkoutMode && /* TODO: Enable this button when checkout v2 is ready and clean up cookie logic button code*/ //   <Button
                                        //     ariaLabel={i18n.continueCheckoutAria(
                                        //       cartItems?.length,
                                        //       `${currencySign}${estimatedTotal}`
                                        //     )}
                                        //     onClick={() =>
                                        //       continueCheckoutEventInfo(checkoutUrl, activeCart)
                                        //     }
                                        //     className="gbh-data-layer checkout-btn-group"
                                        //     label={i18n.checkout}
                                        //     flexible
                                        //     type="black"
                                        //     to={checkoutUrl}
                                        //     disabled={disableCheckout}
                                        //  />
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            ariaLabel: i18n.continueCheckoutAria(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length, "".concat(currencySign).concat(estimatedTotal)),
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                (0,_components_cart_analytics__WEBPACK_IMPORTED_MODULE_15__/* .continueCheckoutEventInfo */ .wt)(checkoutUrl, activeCart);
                                                // Check if checkoutv2=yes cookie exists
                                                if (document.cookie.includes("checkoutv2=yes")) {
                                                    // Force full page reload for v2
                                                    window.location.href = checkoutUrl + "?mode=v2";
                                                } else {
                                                    // Normal SPA navigation
                                                    router.push(checkoutUrl);
                                                }
                                            },
                                            className: "gbh-data-layer checkout-btn-group",
                                            label: i18n.checkout,
                                            flexible: true,
                                            type: "black",
                                            to: checkoutUrl,
                                            disabled: disableCheckout
                                        }),
                                        !checkoutMode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ExpressCheckout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            orderSummary: true
                                        }) : null
                                    ]
                                }),
                                checkoutMode && isPaymentTechnicalErrorFailed && isModalOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "payment-fail-modal",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_17__["default"], {
                                        showModal: isPaymentTechnicalErrorFailed && isModalOpen,
                                        onModalClose: handleModalClose,
                                        labelledBy: "error-message",
                                        hideCloseIcon: false,
                                        i18n: i18n,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "error-title",
                                                children: placeOrderErrorTitleMsg
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "fail-message",
                                                children: placeOrderTechnicalErrorMsg || genericError
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_checkout_OrderReview__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                                i18n: i18n,
                                                orderSummary: true,
                                                cart: activeCart,
                                                placeOrderClick: handleModalClose,
                                                technicalErrorPopup: handletechnicalErrorPopupClose,
                                                errorMessage: placeOrderTechnicalErrorMsg || genericError,
                                                isModalOpen: true
                                            })
                                        ]
                                    })
                                }) : null,
                                checkoutMode && technicalErrorModal && !disablePaymentBtn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "payment-fail-modal",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_17__["default"], {
                                        showModal: technicalErrorModal && !disablePaymentBtn,
                                        onModalClose: paymentButtonDisable,
                                        labelledBy: "error-message",
                                        hideCloseIcon: false,
                                        i18n: i18n,
                                        children: technicalErrorMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error-title",
                                                    children: placeOrderErrorTitleMsg
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "fail-message",
                                                    children: placeOrderErrorMsg
                                                }),
                                                cartKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "user-cart-key",
                                                    children: i18n.yourSharedCartID(cartKey)
                                                }) : null,
                                                placeOrderErrorContactMsg ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "payment-error-contact",
                                                    onClick: (e)=>{
                                                        var ref, ref1;
                                                        var ref2;
                                                        (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__/* .addAnalyticsForErrorMessages */ .fd)("n/a", "n/a", true, (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref2 !== void 0 ? ref2 : "n/a");
                                                    },
                                                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(placeOrderErrorContactMsg)
                                                }) : null,
                                                placeOrderErrorHelpMsg ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "payment-help-msg",
                                                    onClick: (e)=>{
                                                        var ref, ref1;
                                                        var ref2;
                                                        (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_19__/* .addAnalyticsForErrorMessages */ .fd)("n/a", "n/a", true, (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref2 !== void 0 ? ref2 : "n/a");
                                                    },
                                                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(placeOrderErrorHelpMsg)
                                                }) : null
                                            ]
                                        }) : genericError
                                    })
                                }) : null,
                                checkoutMode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_checkout_OrderReview__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                    i18n: i18n,
                                    orderSummary: true,
                                    cart: activeCart,
                                    legalLinks: legalLinks,
                                    placeOrderBtnDisableMsg: placeOrderBtnDisableMsg,
                                    placeOrderClick: handleModalClose,
                                    technicalErrorPopup: handletechnicalErrorPopupClose,
                                    errorMessage: placeOrderTechnicalErrorMsg || genericError
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "cart-accordian",
                    onClick: promoCodeAccordian,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Collapsible__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        title: i18n.promocode,
                        isOpenAccordian: promoCodesData.length,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "cart-accordion-section",
                            children: [
                                promoCodesData.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "cart-promo-code-section",
                                    children: promoCodesData === null || promoCodesData === void 0 ? void 0 : promoCodesData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "promo-code-list",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "cart-promo-code",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "active-promo-name",
                                                        children: item.code
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "promo-right-section",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "active-promo-price",
                                                                children: item.type !== "shipping" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummaryItem__WEBPACK_IMPORTED_MODULE_5__/* .OrderSummaryItem */ .$, {
                                                                    value: Number(item.discount * -1),
                                                                    prefix: currencySign
                                                                }) : ""
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                tabIndex: 0,
                                                                className: "order-summary__close",
                                                                onClick: ()=>{
                                                                    handleRemoveDiscount(item.id, item.code);
                                                                },
                                                                children: i18n.remove
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, i))
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "order-summary__input-group",
                                    onClick: (e)=>e.stopPropagation(),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            id: "promo-code-input",
                                            customClass: "order-summary__input ".concat(promoError ? "--error" : ""),
                                            className: "promo-code-input",
                                            label: i18n.enterPromo,
                                            type: "text",
                                            pattern: "[a-zA-Z0-9]+",
                                            placeholder: i18n.enterPromo,
                                            value: promoCode,
                                            onChange: (e)=>setPromoCode(e.target.value),
                                            onKeyPress: (e)=>e.key === "Enter" && handleAddDiscount(e),
                                            onFocus: ()=>{
                                                setPromoError("");
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            role: "button",
                                            tabIndex: "0",
                                            label: i18n.apply,
                                            size: "small",
                                            type: "ghost",
                                            disabled: status === "loading",
                                            onClick: handleAddDiscount
                                        })
                                    ]
                                }),
                                promoError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    tabIndex: "0",
                                    role: "alert",
                                    id: "kf-cart-promo-error",
                                    className: "order-summary__promo-error",
                                    children: promoError
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderSummary);


/***/ }),

/***/ 24071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OrderSummaryItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);
/* harmony import */ var _components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53683);




const OrderSummaryItem = (param)=>{
    let { label , value , icon , children , id , prefix ="" , freeShipping =null , tooltip =null , alt ="" , role ="" , customCls ="" , valueSize ="" , onClick =()=>{} , decimalScale =2 , onMouseOver , type  } = param;
    const [tooltipFlag, setTooltipFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const keyProp = id ? {
        key: id
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ...keyProp,
            className: "order-summary__item  ".concat(customCls),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "order-summary__item--label",
                    children: [
                        label && label,
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: icon,
                            role: role !== null && role !== void 0 ? role : "tooltip",
                            margin: "unset",
                            alt: alt,
                            className: "order-summary__tooltip-icon",
                            onMouseOver: ()=>{
                                setTooltipFlag(true);
                                onMouseOver(type);
                            },
                            onMouseOut: ()=>setTooltipFlag(false),
                            onClick: onClick
                        }),
                        children && children,
                        tooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "order-summary__tooltip--".concat(tooltipFlag ? "show" : "hide"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "order-summary__tooltip-wrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    message: tooltip
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "order-summary__item--value".concat(valueSize ? "-".concat(valueSize) : ""),
                    children: !isNaN(value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
                        value: parseFloat(value !== null && value !== void 0 ? value : 0).toFixed(decimalScale),
                        displayType: "text",
                        thousandSeparator: true,
                        prefix: prefix !== null && prefix !== void 0 ? prefix : ""
                    }) : value
                })
            ]
        })
    });
};


/***/ }),

/***/ 67271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OrderSummary_ShippingInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx + 1 modules
var Accordion = __webpack_require__(51952);
// EXTERNAL MODULE: ./components/PreviewCart/v1/PreviewCartTile.jsx
var PreviewCartTile = __webpack_require__(70561);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/cart/OrderSummary/ShippingInfo/analytics/index.js

const getEventInfoAnalytics = (data)=>{
    const { type: typeInit , needsProductInfo =false , productName ="" , accordionStatus ={} , isBundle =""  } = data;
    let type = typeInit;
    const status = accordionStatus["status"] ? "collapse" : "expand";
    if (type === "Parcel") {
        type = "parcel shipping";
    } else if (type === "LTL") {
        type = "freight shipping";
    } else if (type === "Services") {
        type = "e-delivery";
    }
    return JSON.stringify({
        eventAction: "checkout:order summary:".concat(type, " ").concat(needsProductInfo ? "product" : status),
        eventName: "checkout:order summary:".concat(type, " ").concat(needsProductInfo ? "product" : status),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: needsProductInfo ? (0,helper/* sanitizeTextForAnalytics */.T68)(productName) : status,
        internalLinkPosition: "checkout".concat(isBundle ? ":bundle" : ""),
        internalLinkType: "checkout:" + type,
        internalLinkZoneName: "checkout:order summary",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};

// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./components/cart/OrderSummary/ShippingInfo/index.jsx









const ShippingInfo = (props)=>{
    const { i18n , cartItems =[] , shippingItems =[] , data: { presetConfigs =""  } = {}  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { showShippingDetailsForReview  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [shipItems, setShipItems] = (0,react.useState)([]);
    const [accordionStatus, setAccordionStatus] = (0,react.useState)({
        Parcel: false,
        LTL: false,
        Services: false
    });
    const cartCount = (0,cart/* getCartCount */.c0)();
    (0,react.useEffect)(()=>{
        const parcelItems = [];
        var ref;
        const bundleParent = (ref = cartItems.filter((prod)=>prod.isBundleParent)) !== null && ref !== void 0 ? ref : [];
        parcelItems.push(...bundleParent);
        shippingItems.map((item)=>{
            const { parentLineItemId ="" , lineItemId =""  } = item;
            if (parentLineItemId) {
                const comboChild = cartItems.find((prod)=>prod.id === lineItemId) || {};
                if (parcelItems.find((prod)=>prod.id === parentLineItemId)) {
                    var ref;
                    const comboParent = parcelItems.find((prod)=>prod.id === parentLineItemId) || {};
                    (ref = comboParent.childItems) === null || ref === void 0 ? void 0 : ref.push(comboChild);
                } else {
                    const comboParent1 = {
                        ...cartItems.find((prod)=>prod.id === parentLineItemId) || {}
                    };
                    comboParent1.childItems = [
                        comboChild
                    ];
                    parcelItems.push(comboParent1);
                }
            } else {
                const cartItem = cartItems.find((prod)=>prod.id === lineItemId) || {};
                parcelItems.push(cartItem);
            }
        });
        setShipItems(parcelItems);
    }, [
        shippingItems,
        cartItems
    ]);
    const updateStatus = (type, status)=>{
        setAccordionStatus({
            ...accordionStatus,
            ...{
                status
            }
        });
        dispatch((0,cartSlice/* setShowShippingDetails */.w9)({
            ...showShippingDetailsForReview,
            [type]: status
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "shipping-accordion",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shipping-accordion__separator"
                    }),
                    shippingItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        isOpen: false,
                        title: i18n.inYourCart(shipItems ? cartCount : "  "),
                        analyticTitleData: getEventInfoAnalytics({
                            type: "Parcel",
                            accordionStatus
                        }),
                        handleOpen: ()=>updateStatus("Parcel", true),
                        handleClose: ()=>updateStatus("Parcel", false),
                        children: shipItems.map((item, i)=>{
                            if (item === null || item === void 0 ? void 0 : item.id) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCartTile/* default */.Z, {
                                        i18n: i18n,
                                        checkoutMode: true,
                                        currencySign: props.currencySign,
                                        data: item,
                                        productEventInfo: getEventInfoAnalytics({
                                            type: "Parcel",
                                            needsProductInfo: true,
                                            productName: item.name || item.desc,
                                            accordionStatus,
                                            isBundle: item === null || item === void 0 ? void 0 : item.isBundleParent
                                        }),
                                        presetConfigs: presetConfigs
                                    })
                                }, i);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var OrderSummary_ShippingInfo = (ShippingInfo);


/***/ }),

/***/ 73272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7872);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46201);
/* harmony import */ var _components_checkout_checkoutHelperFunction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37012);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78145);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var _components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82883);
/* harmony import */ var _components_cart_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56243);
/* harmony import */ var _components_cart_OrderSummary_ShippingInfo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67271);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11859);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60475);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24400);
/* harmony import */ var _components_checkout_PaymentMethod_AciPayment_localization__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44047);
/* harmony import */ var _components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27173);
/* harmony import */ var _components_checkout_PaymentMethod_ChekoutErrorMessage__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83566);
/* harmony import */ var _components_checkout_analytics_index__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71289);


















const OrderReview = (props)=>{
    const { i18n , legalLinks ={} , status , statusCode ={} , shippingDone , shippingItems , setStepLoading , cart , summaryProps ={} , shippingProps ={} , orderSummary =false , placeOrderClick =()=>{} , placeOrderBtnDisableMsg ="" , technicalErrorPopup =()=>{} , errorMessage ="" , isModalOpen =false  } = props;
    const { isPaymentDisableAction =false , placeOrderCounts =1  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .checkoutState */ .TG);
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const [taxDown, setTaxDown] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [disablePaymentBtn, setDisablePaymentBtn] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isPaymentDisableAction) {
            setDisablePaymentBtn(true);
        }
    }, [
        isPaymentDisableAction
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const { isPaymentInfo =false , checkoutStep , isPaymentTechnicalErrorFailed =false  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .checkoutState */ .TG);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)("common");
    const staticText = (0,_components_checkout_PaymentMethod_AciPayment_localization__WEBPACK_IMPORTED_MODULE_17__/* .getTranslations */ .F)(t);
    const { genericError =""  } = staticText;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (status === (statusCode === null || statusCode === void 0 ? void 0 : statusCode.EDIT)) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_4__/* .setShowShippingDetails */ .w9)({
                Parcel: true,
                LTL: true,
                Services: true
            }));
        }
    }, []);
    const handleSubmit = async function() {
        let isModalOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setStepLoading && setStepLoading(true);
        const res = await _components_checkout_checkoutHelperFunction__WEBPACK_IMPORTED_MODULE_5__/* .refreshCart */ .qN;
        if (res) {
            if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .checkCartStock */ .KzD)(cart)) {
                (0,_components_checkout_checkoutHelperFunction__WEBPACK_IMPORTED_MODULE_5__/* .checkInactivePromos */ .xj)(setStepLoading, _components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_8__/* .addPlaceOrderDataLayer */ .Ye, isModalOpen);
            }
        } else {
            setStepLoading && setStepLoading(false);
            (0,_components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_8__/* .addPlaceOrderDataLayer */ .Ye)();
        }
    };
    const checkTaxFlag = ()=>{
        var ref, ref1;
        dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .setIsPaymentInfoAction */ .hK)(false));
        if (isPaymentTechnicalErrorFailed) {
            technicalErrorPopup();
            if (errorMessage && isModalOpen) {
                (0,_components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_14__/* .addAnalyticsForErrorMessages */ .fd)(errorMessage, "failure", isModalOpen);
            }
            dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .setPlaceOrderCountsAction */ .jJ)(placeOrderCounts + 1));
            if (placeOrderCounts > 2) {
                dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .setPaymentTechnicalFailedAction */ .t5)(false));
                dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_12__/* .setPaymentDisableBtnAction */ .Pk)(true));
                placeOrderClick();
            }
        }
        if (cart === null || cart === void 0 ? void 0 : (ref = cart.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.taxCalculationFlag) {
            handleSubmit(isModalOpen);
        } else {
            setTaxDown(true);
            (0,_components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_8__/* .addPlaceOrderDataLayer */ .Ye)();
        }
    };
    const onTaxModalClose = ()=>{
        placeOrderClick();
        setTaxDown(false);
        handleSubmit(isModalOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "taxware-down",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    showModal: taxDown,
                    onModalClose: onTaxModalClose,
                    labelledBy: "taxware-down-title",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "taxware-down-title",
                            className: "taxware-down__title",
                            children: i18n.taxDownTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "taxware-down__desc",
                            children: i18n.taxDownDesc
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            customClass: "taxware-down__cta",
                            role: "button",
                            flexible: true,
                            label: i18n.continue,
                            onClick: onTaxModalClose
                        })
                    ]
                })
            }),
            status === statusCode.EDIT && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "review-order",
                children: [
                    !orderSummary ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "review-order__order-summary",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                checkoutMode: true,
                                i18n: i18n,
                                ...summaryProps
                            }),
                            width < 992 && shippingDone && shippingItems.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_ShippingInfo__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                i18n: i18n,
                                cartItems: summaryProps === null || summaryProps === void 0 ? void 0 : summaryProps.cartItems,
                                shippingItems: shippingItems,
                                currencySign: summaryProps === null || summaryProps === void 0 ? void 0 : summaryProps.currencySign,
                                ...shippingProps
                            })
                        ]
                    }) : null,
                    orderSummary && checkoutStep >= 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "review-order__cta",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    role: "button",
                                    type: "black",
                                    label: i18n.placeOrder,
                                    onClick: checkTaxFlag,
                                    disabled: disablePaymentBtn || !isPaymentInfo
                                })
                            }),
                            disablePaymentBtn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "paymentDisableMessage",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_checkout_PaymentMethod_ChekoutErrorMessage__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    customPaymentErrorMsg: placeOrderBtnDisableMsg,
                                    genericPaymentErrorMsg: genericError,
                                    onLinkClick: _components_checkout_PaymentMethod_analytics__WEBPACK_IMPORTED_MODULE_14__/* .addAnalyticsForErrorCheckout */ .Ve
                                })
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "review-order__mssg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "review-order__desc",
                                    children: [
                                        i18n.agreeMssg,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: legalLinks === null || legalLinks === void 0 ? void 0 : legalLinks.termsOfService,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>{
                                                return (0,_components_checkout_analytics_index__WEBPACK_IMPORTED_MODULE_16__/* .addServiceAnalyticsData */ .yy)("terms of use", legalLinks === null || legalLinks === void 0 ? void 0 : legalLinks.termsOfService);
                                            },
                                            children: i18n.termsOfUse
                                        }),
                                        i18n.acknowledgeMssg,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: legalLinks.privacyPolicy,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>{
                                                return (0,_components_checkout_analytics_index__WEBPACK_IMPORTED_MODULE_16__/* .addServiceAnalyticsData */ .yy)("privacy policy", legalLinks === null || legalLinks === void 0 ? void 0 : legalLinks.privacyPolicy);
                                            },
                                            children: i18n.privacyPolicy
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (OrderReview);


/***/ }),

/***/ 78803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81147);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Collapsible = (props)=>{
    const { title , children , isOpenAccordian , customClassName =""  } = props;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleClick = ()=>{
        setIsOpen(!isOpen);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsOpen(!!isOpenAccordian);
    }, [
        isOpenAccordian
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().Collapsible), " ").concat(customClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "header ".concat(isOpen ? "open" : ""),
                tabIndex: "0",
                onClick: handleClick,
                "aria-expanded": isOpen,
                role: "button",
                children: title
            }),
            isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "body",
                children: children
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Collapsible);


/***/ }),

/***/ 81147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Collapsible":"Collapsible_Collapsible__wSKwc"};

/***/ })

}]);